import _ from 'lodash'

import { filterKeys } from '../../configuration/filtering'
import { filterToursByField } from './filterToursByField'

function removeRoundTripsFromDestinationResults(tours, destinations) {
  return _.filter(tours, tour => {
    const destinationStart = _.get(tour, `[${filterKeys.destinationStart}]`, [])
    const destinationEnd = _.get(tour, `[${filterKeys.destinationEnd}]`, [])
    const vacationTypes = _.get(tour, `[${filterKeys.vacationTypes}]`, [])

    const isRoundTripFromDestinationResults = _.isEqual(destinationStart, destinationEnd)
      && Boolean(_.find(vacationTypes, option => _.toLower(option) === 'roundtrip vacations'))
      && _.includes(destinations, _.get(destinationStart, '[0]'))
    
    return !isRoundTripFromDestinationResults
  })
}

export function filterTours(tours, filterState, isDestinationPage) {
  const exactMatchFilters = _.get(filterState, 'matchExactly', [])
  const filterableFields = _.keys(_.omit(filterState, ['matchExactly']))
  let filteredTours = tours
  _.forEach(filterableFields, key => {
    const exactMatch = _.includes(exactMatchFilters, key)
    filteredTours = filterToursByField(filteredTours, key, filterState[key], exactMatch)
  })

  // client ask to remove all round trips from destination specific pages (ticket # YLG201-706)
  const destinationFilters = _.get(filterState, `[${filterKeys.destinationIncludes}]`, [])
  if (isDestinationPage && !_.isEmpty(destinationFilters)) {
    filteredTours = removeRoundTripsFromDestinationResults(filteredTours, destinationFilters)
  }

  return filteredTours
}
